"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _headerModule = _interopRequireDefault(require("./header.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _headerMenu = _interopRequireDefault(require("../headerMenu/headerMenu"));

var _aragLogo = _interopRequireDefault(require("../../../styles/images/aragLogo.png"));

var _phoneicon = _interopRequireDefault(require("../../../styles/images/phoneicon.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(props) {
  var id = props.id,
      mainImage = props.mainImage,
      mainCollapsedImage = props.mainCollapsedImage,
      telephone = props.telephone,
      isCollapsed = props.isCollapsed,
      headerTitle = props.headerTitle,
      subTitle = props.subTitle,
      onLogoClick = props.onLogoClick,
      menuItems = props.menuItems;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)("row", _headerModule.default["layout-row"])
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_row") : null,
    className: "row"
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_col") : null,
    className: (0, _classnames.default)("col-sm-12")
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_head") : null,
    className: _headerModule.default["head"]
  }, _react.default.createElement("img", {
    id: id ? "".concat(id, "_head_img") : null,
    onClick: onLogoClick,
    src: _aragLogo.default,
    alt: "ARAG",
    className: _headerModule.default["logo"]
  }), !isCollapsed ? _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_menu_items") : null
  }, menuItems && _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_menu_wrapper") : null,
    className: _headerModule.default['header-menu']
  }, _react.default.createElement(_headerMenu.default, {
    id: id ? "".concat(id, "_header_menu") : null,
    menuItems: menuItems
  })), _react.default.createElement("div", {
    id: id ? "".concat(id, "_telefon") : null,
    className: (0, _classnames.default)(_headerModule.default["telefon"], _headerModule.default["clearfix"])
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_telefon_content") : null,
    className: _headerModule.default["telContent"]
  }, telephone && _react.default.createElement("a", {
    id: id ? "".concat(id, "_telefon_link") : null,
    className: _headerModule.default["telLink"],
    href: "tel:".concat(telephone)
  }, telephone)))) : _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_image_collapsed") : null,
    className: (0, _classnames.default)(_headerModule.default["header"], _headerModule.default["image-collapsed"])
  }, menuItems && _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_menu_wrapper") : null,
    className: _headerModule.default['header-menu']
  }, _react.default.createElement(_headerMenu.default, {
    id: id ? "".concat(id, "_header_menu") : null,
    menuItems: menuItems
  })), _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_image_container") : null,
    className: _headerModule.default["imgContainer"]
  }, _react.default.createElement("img", {
    id: id ? "".concat(id, "_header_main_image") : null,
    src: mainCollapsedImage ? mainCollapsedImage : mainImage,
    alt: "Arag Main Photo"
  })), _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_text") : null,
    className: _headerModule.default["text"]
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_telephone") : null,
    className: _headerModule.default["telephone"]
  }, _react.default.createElement("img", {
    id: id ? "".concat(id, "_header_telephone_logo") : null,
    className: _headerModule.default["telephone-logo"],
    src: _phoneicon.default,
    alt: "phoneicon"
  }), _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_telephone_number") : null,
    className: _headerModule.default["telephone-number"]
  }, telephone && _react.default.createElement("a", {
    id: id ? "".concat(id, "_header_telephone_link") : null,
    className: _headerModule.default["telLink"],
    href: "tel:".concat(telephone)
  }, telephone)))))))), _react.default.createElement("div", {
    id: id ? "".concat(id, "_main_image_row") : null,
    className: 'row'
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_main_image_col") : null,
    className: 'col-xs-12'
  }, !isCollapsed && _react.default.createElement("div", {
    id: id ? "".concat(id, "_main_image_header") : null,
    className: _headerModule.default["header"]
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_main_image_container") : null,
    className: _headerModule.default["imgContainer"]
  }, _react.default.createElement("img", {
    id: id ? "".concat(id, "_main_image") : null,
    src: mainImage,
    alt: "Arag Collapsed Photo"
  })), headerTitle && _react.default.createElement("div", {
    id: id ? "".concat(id, "_header_title_wrapper") : null,
    className: _headerModule.default["text"],
    style: {
      opacity: 1
    }
  }, _react.default.createElement("h1", {
    id: id ? "".concat(id, "_header_title") : null,
    className: _headerModule.default["header-text"]
  }, headerTitle), subTitle && _react.default.createElement("p", {
    id: id ? "".concat(id, "_sub_title") : null,
    className: _headerModule.default["sub-text"]
  }, subTitle))))));
};

Header.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** The src of an image */
  mainImage: _propTypes.default.string,

  /** The src of an collapsed Image */
  mainCollapsedImage: _propTypes.default.string,

  /** The css of the main image */
  mainImageStyle: _propTypes.default.object,

  /** isCollapsed shrinks the mainImage to the top and replace the telephone placeholder */
  isCollapsed: _propTypes.default.bool,

  /** The string of a telephone */
  telephone: _propTypes.default.string,

  /** The string of a headerTitle */
  headerTitle: _propTypes.default.string,

  /** The string of a subTitle */
  subTitle: _propTypes.default.string,

  /** A function for the logo */
  onLogoClick: _propTypes.default.func,

  /** An array to be used like the HeaderMenu component */
  menuItems: _propTypes.default.array
};
var _default = Header;
exports.default = _default;